import TopNav from "@/pages/home/components/TopNav";
import Hero from "@/pages/home/components/Hero";
import LiveRank from "@/pages/home/components/LiveRank";
import StoryStream from "@/pages/home/components/StoryStream";
import ArenaSection from "@/pages/home/components/ArenaSection";
import ChampionSection from "@/pages/home/components/ChampionSection";
import HowItWorks from "@/pages/home/components/HowItWorks";
import CtaBanner from "@/pages/home/components/CtaBanner";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <TopNav />
      <main>
        <Hero />
        <LiveRank />
        <StoryStream />
        <ArenaSection />
        <ChampionSection />
        <HowItWorks />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}